<template>
    <div class="row">
        <div class="col-6">
            <csp-form-group-radio :form="adversaryForm" :options="genderOptions"
                property="gender" required/>
        </div>

        <div v-if="!isGenderPerson" class="col-md-6">
            <csp-form-group-input :form="adversaryForm"
                property="companyName" :required="isGenderCompany"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-input :form="adversaryForm"
                :label-property="isGenderCompany ? 'companyFistName' : ''"
                property="firstName" :required="isNameRequired"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-input :form="adversaryForm"
                :label-property="isGenderCompany ? 'companyLastName' : ''"
                property="lastName" :required="isNameRequired"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-input :form="adversaryForm" property="cargo" required/>
        </div>

        <!-- Force next columns to break to new line -->
        <div class="w-100"/>

        <div class="col-md-6">
            <csp-form-group-select-insurance-policy-parent
                :insurance-policy-form="adversaryForm.getSubform('insurancePolicy')"
                property="parentInsuranceId"/>
        </div>

        <div class="col-md-6">
            <csp-form-group-input :form="adversaryForm" property="adversaryInsuranceReference"/>
        </div>

        <div v-if="showMinimalRecordCheckbox && recordForm.isMinimalRecordCreationAllowed()" class="col-md-6">
            <csp-form-group-checkbox :form="recordForm"
                label-property="inputNotRequired" property="minimalRecordCreation"/>
        </div>
    </div>
</template>

<script>
    import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';
    import GenderEnum from '@js/enums/GenderEnum';
    import {buildOptionsGender} from '@js/functions/form/select';

    export default {
        props: {
            recordForm: {
                type: RecordCreateForm,
                required: true,
            },
            showMinimalRecordCheckbox: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                genderOptions: [],
            }
        },
        computed: {
            adversaryForm() {
                return this.recordForm.getSubform('adversary');
            },
            isGenderCompany() {
                return this.adversaryForm.getDataOfProperty('gender') === GenderEnum.COMPANY;
            },
            isGenderPerson() {
                const gender = this.adversaryForm.getDataOfProperty('gender');
                return gender === GenderEnum.MALE || gender === GenderEnum.FEMALE;
            },
            isNameRequired() {
                return !this.isGenderCompany;
            },
        },
        async mounted() {
            this.genderOptions = await buildOptionsGender();
        },
    }
</script>
